export default String.raw`
{% assign discount = customer-profile.DiscountERPDetails -%}
{% if include -%}
	{% assign elementsParent = include -%}
{% else -%}
	{% assign elementsParent = discount -%}
{% endif -%}

<div class="eshop__table-container discount-elements-table-js">
	{% assign anyGroup = false -%}
	{% assign anyProduct = false -%}
	{% assign anyThreshold = false -%}
	{% assign anyBundleThreshold = false -%}
	{% assign anyBundleQuantity = false -%}
	{% assign anyTotalPrice = false -%}
	{% assign anySubtotalPrice = false -%}
	{% for element in elementsParent.Elements -%}
		{% if element.Group != null -%}
			{% assign anyGroup = true -%}
		{% endif -%}
		{% if element.Product != null -%}
			{% assign anyProduct = true -%}
		{% endif -%}
		{% if element.Threshold != null and element.Threshold > 0 -%}
			{% assign anyThreshold = true -%}
		{% endif -%}
		{% if element.BundleThreshold != null and element.BundleThreshold > 0 -%}
			{% assign anyBundleThreshold = true -%}
		{% endif -%}
		{% if element.BundleQuantity != null and element.BundleQuantity > 0 -%}
			{% assign anyBundleQuantity = true -%}
		{% endif -%}
		{% if element.FixedPrice -%}
			  {% assign anyFixedPrice = true -%}
			{% if element.TotalPrice != null and element.TotalPrice > 0 -%}
				{% assign anyTotalPrice = true -%}
			{% endif -%}
			{% if element.SubtotalPrice != null and element.SubtotalPrice > 0 -%}
				{% assign anySubtotalPrice = true -%}
			{% endif -%}
		{% endif -%}
	{% endfor -%}
	<table>
		<colgroup>
			<col style="width:130px">
			<col style="width:80px">
		{% if anyThreshold or anyBundleThreshold or anyTotalPrice -%}
			<col style="width:80px">
		{% endif -%}
		</colgroup>
        <div class="products-table-header-js">
			<thead>
				<tr class="products-table-header-container-js">
					<th class="id name-and-code-js">
						{% if anyGroup and anyProduct -%}
							{{translations.Product}}/{{translations.Category}}
						{% elseif anyGroup -%}
							{{translations.Category}}
						{% else -%}
							{{translations.Product}}
						{% endif -%}
					</th>
					{% if anyBundleQuantity -%}
					<th class="price-like-column-js prices-view-js">
						{{translations.Quantity}}
					</th>
					{% endif -%}
					{% unless anyFixedPrice and anySubtotalPrice == false -%}
					<th class="price-like-column-js prices-view-js">
						{% if anyFixedPrice and anySubtotalPrice -%}
							{{translations.Price}} {{translations.Netto | Downcase }}
						{% else -%}
							{{translations.Discount}}
						{% endif -%}
					</th>
					{% endunless -%}
					{% if anyThreshold or anyBundleThreshold or anyTotalPrice -%}
					<th class="price-like-column-js prices-view-js">
						{% if anyFixedPrice and anyTotalPrice -%}
							{{translations.Price}} {{translations.Brutto | Downcase}}
						{% elseif anyBundleThreshold -%}
							{{translations.BundleThreshold}}
						{% else -%}
							{{translations.Threshold}}
						{% endif -%}
					</th>
					{% endif -%}
				</tr>
			</thead>
        </div>
		<tbody>
		{% for element in elementsParent.Elements -%}
			{% assign index = forloop.index -%}
			{% if index == 1 -%}
			<script>
				if(typeof gtag != 'undefined'){
					gtag("event", "view_promotion", {
						promotion_name: '{% if discount.Name != null -%}{{ discount.Name }}{% else -%}{{ translations.AllProducts }}{% endif -%}',
						items: [{ item_id: '{% if element.Group != null -%}{{ element.Group.Id }}{% elseif element.Product != null -%}{{ element.Product.Id }}{% else -%}1{% endif -%}', item_name: '{% if element.Group != null -%}{{ element.Group.Name }}{% elseif element.Product != null -%}{{ element.Product.NameNoHtml }}{% else -%}{{ translations.AllProducts }}{% endif -%}' }]
					});
				}
			</script>
			{% endif -%}
            <tr class="cart-product-container-js">
                <!-- <td class="id">
                    {{ forloop.index }}
                </td> -->
				<td class="product-cell name-and-code-js">
					<span class="product-name id">
						{% if element.Group != null -%}
							{% if element.Group.Url -%}
								<a class="select-discount-js" href="{{ page.BaseHref }}{{ element.Group.Url }}" data-name="{% if discount.Name != null -%}{{ discount.Name }}{% else -%}{{ translations.AllProducts }}{% endif -%}">
							{% endif -%}
									{{ element.Group.Name }}
							{% if element.Group.Url -%}
								</a>
							{% endif -%}
						{% elseif element.Product != null -%}
							{% if element.Product.Url -%}
								<a class="select-discount-js" href="{{ page.BaseHref }}{{ element.Product.Url }}" data-name="{% if discount.Name != null -%}{{ discount.Name }}{% else -%}{{ translations.AllProducts }}{% endif -%}">
							{% endif -%}
									{{ element.Product.NameNoHtml }}
							{% if element.Product.Url -%}
								</a>
							{% endif -%}
						{% else -%}
							{{ translations.AllProducts }}
						{% endif -%}
					</span>
				</td>
				{% if anyBundleQuantity -%}
				<td class="{% if anyThreshold or anyBundleThreshold or anyTotalPrice -%}  {% endif -%} price-like-column-js prices-view-js">
					{% if element.BundleQuantity > 0 -%}
							{{ element.BundleQuantity | Normalize }}
					{% endif -%}
				</td>
                {% endif -%}
				{% unless anyFixedPrice and anySubtotalPrice == false -%}
				<td class="prices-view-js">
					{% if element.FixedPrice -%}
						{% if element.SubtotalPrice > 0 -%}
							{{ element.SubtotalPrice | ToPrice }}
						{% endif -%}
					{% else -%}
						{% if element.Type == 1 or element.Type == 3 or element.Type == 9 -%}
							{{ element.Value | ToPrice }}
						{% else -%}
							{{ element.Value | Normalize }}
						{% endif -%}
					{% endif -%}
					{{ element.ValueSymbol }}
				</td>
				{% endunless -%}
				{% if anyThreshold or anyBundleThreshold or anyTotalPrice -%}
				<td class="prices-view-js">
					{% if element.FixedPrice -%}
						{% if element.TotalPrice > 0 -%}
							{{ element.TotalPrice | ToPrice }}
						{% endif -%}
						{{ element.ValueSymbol }}
					{% elseif element.BundleThreshold > 0 -%}
						{% if element.Type == 1 or element.Type == 3 or element.Type == 9 -%}
							{{ element.BundleThreshold | ToPrice }}
						{% else -%}
							{{ element.BundleThreshold | Normalize }}
						{% endif -%}
						{{ element.BundleThresholdSymbol }}
					{% elseif element.Threshold > 0 -%}
						{% if element.Type == 1 or element.Type == 3 or element.Type == 9 -%}
							{{ element.Threshold | ToPrice }}
						{% else -%}
							{{ element.Threshold | Normalize }}
						{% endif -%}
						{{ element.ThresholdSymbol }}
					{% endif -%}
				</td>
				{% endif -%}
			</tr>
        {% endfor -%}
		</tbody>
	</table>
</div>
{% assign paginationPageCount = discount.PageCount -%}
{% if paginationPageCount > 1 -%}
	{% include 'partials/common/pagination.html' -%}
{% endif -%}
`